import classNames from 'classnames';
import React, { Component } from 'react';
import { Icon } from '@material-ui/core';
import ReportTabs, { ReportTabsProps } from '../../molecules/ReportTabs';
import ContentHeader, { ContentHeaderProps } from '../ContentHeader';
import { AnnotationTooltipProps } from '../../molecules/AnnotationTooltip';
import { GASpotEventState } from '../NegotiationCountList';

interface ReportHeaderProps {
  header: ContentHeaderProps;
  tooltipInfo: AnnotationTooltipProps;
  onTabClick: () => void;
  gaSpotEvent?: GASpotEventState;
}

type OwnProps = ReportHeaderProps & ReportTabsProps;

class ReportHeader extends Component<OwnProps, {}> {
  render() {
    return (
      <div className='layout-tab__header u-bg-white'>
        <div className='container u-pb0'>
          <ContentHeader
            screenId={this.props.header.screenId}
            screenName={this.props.header.screenName}
            statusType={this.props.header.statusType}
            loadingStatus={this.props.header.loadingStatus}
            titleIcon={
              <div
                className={classNames(
                  'dashboard-summary-icon-wrap dashboard-summary-icon-wrap--small u-float-left u-mr8',
                  `dashboard-summary-icon-wrap--${this.props.header.statusType}`
                )}>
                <Icon className='dashboard-summary-icon'>{this.props.header.screenId === 'total' ? 'list_bulleted' : 'description'}</Icon>
              </div>
            }
            tooltipInfo={this.props.tooltipInfo}
            gaSpotEvent={this.props.gaSpotEvent}
            data-testid='contentHeader'>
            {this.props.children}
          </ContentHeader>
        </div>

        <ReportTabs
          activeTabKey={this.props.activeTabKey}
          tabList={this.props.tabList}
          data-testid='reportTabs'
          onTabClick={this.props.onTabClick}
        />
      </div>
    );
  }
}

export default ReportHeader;
